import { IDeletedAppointment } from '../Client/IDeletedAppointment'

export const GET_DELETED_APPOINTMENTS_SUCCESS =
  'GET_DELETED_APPOINTMENTS_SUCCESS'
export const GET_DELETED_APPOINTMENTS_FAILURE =
  'GET_DELETED_APPOINTMENTS_FAILURE'
export const GET_DELETED_APPOINTMENTS_LOADING =
  'GET_DELETED_APPOINTMENTS_LOADING'

interface IGetDeletedAppointmentSuccess {
  type: typeof GET_DELETED_APPOINTMENTS_SUCCESS
  payload: {
    deletedAppointments: IDeletedAppointment[]
  }
}

interface IGetDeletedAppointmentFailure {
  type: typeof GET_DELETED_APPOINTMENTS_FAILURE
  payload: {
    error: string
  }
}

interface IGetDeletedAppointmentLoading {
  type: typeof GET_DELETED_APPOINTMENTS_LOADING
}

export type TActionTypes =
  | IGetDeletedAppointmentSuccess
  | IGetDeletedAppointmentFailure
  | IGetDeletedAppointmentLoading
